module.exports = __webpack_public_path__ + "product/product-step-f24dad8502092f6515d989175bf9ed62.png";